import * as types from '../constants/action-types';
import { Entitlements } from '../../../../api/api-entitlements';
import _ from 'lodash';


export function fetchEntitlements (accessToken, profile) {
  const ssoId = _.get(profile, 'SSOid', '');
  return dispatch => {
    const query = `created_by_sso_id=${ssoId}&class=HOST_REFERRAL`;

    dispatch({ type: types.ENTITLEMENTS_FETCH_REQUEST, isFetching: true });

    Entitlements.readEntitlementQuery(query, accessToken, (response) => {
      if (400 < response.statusCode) {
        return dispatch({
          type: types.ENTITLEMENTS_FETCH_FAILURE,
          error: response.message,
          isFetching: false
        });
      }

      return dispatch({
        type: types.ENTITLEMENTS_FETCH_SUCCESS,
        entitlementsArray: response.entitlements,
        isFetching: false
      });
    });
  };
}
